module.exports = __webpack_public_path__ + "static/AWC_Square-5dc9f30b69259eeb11b5fb0e324c43f4.jpg";